import React from "react";
import { ReferenceTypes } from "../../../enums/ReferenceTypes";
import { IAppEntity } from "../../entities";
import { NFLookupMovings } from "../../../components/Shared/NewForms/NFLookupMoving";
import FixedAssetsMovingsDetail from "../../../components/Pages/Documents/FixedAssetsMovings/FixedAssetsMovingsDetail";
import FixedAssetsMovingsList from "../../../components/Pages/Documents/FixedAssetsMovings/FixedAssetsMovingsList";
import { CreateFixedAssetsMovingDto } from "../../../dtos/documents/FixedAssetsMoving/CreateFixedAssetsMovingDto";
import { FixedAssetsMovingService } from "../../../services/documents/FixedAssetsMovingService";

export const FixedAssetsMoving: IAppEntity = {
  entityType: "document",
  title: "Moving",
  pluralTitle: "Movings",
  apiUrl: "FixedAssetsMovings",
  apiEnum: ReferenceTypes.DocumentFixedAssetsMoving,
  getDetailViewComponent: (
    model: any,
    modelUpdatedEvent: (model: any) => void
  ) =>
    React.createElement(FixedAssetsMovingsDetail, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(FixedAssetsMovingsList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getLookupComponent(model: any): any {
    return React.createElement(NFLookupMovings, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog,
    });
  },
  getDataService: () => new FixedAssetsMovingService("FixedAssetsMovings"),
  getEmptyModel: () => {
    const model: CreateFixedAssetsMovingDto = {
      totalAmount: 0,
      totalAmountVat: 0,
      status: 0,
      
      documentDate: new Date(),
      createdDate: new Date(),
      fixedAssets: [],
    };
    return model;
  },
};
